module.exports = __webpack_public_path__ + "img/CECA_B.879af102.png";